(function () {
  function getOptionValue(variant, index) {
    if (variant.options && variant.options[index] !== undefined) {
      return variant.options[index];
    }

    return variant['option' + (index + 1)];
  }

  function updateOptionsInSelector(selectorIndex, parent) {
    var key;
    var selector;

    if (selectorIndex === 0) {
      key = 'root';
      selector = $(parent + ' .single-option-selector:eq(0)');
    }

    if (selectorIndex === 1) {
      key = $(parent + ' .single-option-selector:eq(0)').val();
      selector = $(parent + ' .single-option-selector:eq(1)');
    }

    if (selectorIndex === 2) {
      key = $(parent + ' .single-option-selector:eq(0)').val();
      key += ' / ' + $(parent + ' .single-option-selector:eq(1)').val();
      selector = $(parent + ' .single-option-selector:eq(2)');
    }

    var availableOptions = Shopify.optionsMap[key] || [];

    $(parent + ' .swatch[data-option-index="' + selectorIndex + '"] .swatch-element').each(function () {
      var $swatch = $(this);
      var value = $swatch.attr('data-value');

      if ($.inArray(value, availableOptions) !== -1) {
        $swatch.show().removeClass('soldout');
        $swatch.find(':radio').removeAttr('disabled');
      } else {
        $swatch.hide().addClass('soldout');
        $swatch.find(':radio').removeAttr('checked').attr('disabled', 'disabled');
      }
    });

    if (selector && selector.length) {
      selector.find('option').each(function () {
        var $option = $(this);

        if ($option.val() === '') {
          return;
        }

        if ($.inArray($option.val(), availableOptions) !== -1) {
          $option.prop('disabled', false).show();
        } else {
          $option.prop('disabled', true).hide();
        }
      });
    }
  }

  function linkOptionSelectors(product, parent) {
    Shopify.optionsMap = {};

    for (var i = 0; i < product.variants.length; i++) {
      var variant = product.variants[i];

      var option1 = getOptionValue(variant, 0);
      var option2 = getOptionValue(variant, 1);
      var option3 = getOptionValue(variant, 2);

      Shopify.optionsMap.root = Shopify.optionsMap.root || [];
      Shopify.optionsMap.root.push(option1);
      Shopify.optionsMap.root = Shopify.uniq(Shopify.optionsMap.root);

      if (product.options.length > 1) {
        Shopify.optionsMap[option1] = Shopify.optionsMap[option1] || [];
        Shopify.optionsMap[option1].push(option2);
        Shopify.optionsMap[option1] = Shopify.uniq(Shopify.optionsMap[option1]);
      }

      if (product.options.length === 3) {
        var key = option1 + ' / ' + option2;
        Shopify.optionsMap[key] = Shopify.optionsMap[key] || [];
        Shopify.optionsMap[key].push(option3);
        Shopify.optionsMap[key] = Shopify.uniq(Shopify.optionsMap[key]);
      }
    }

    updateOptionsInSelector(0, parent);
    if (product.options.length > 1) updateOptionsInSelector(1, parent);
    if (product.options.length === 3) updateOptionsInSelector(2, parent);

    $(parent + ' .single-option-selector:eq(0)')
      .off('change.customVariantFix')
      .on('change.customVariantFix', function () {
        updateOptionsInSelector(1, parent);
        if (product.options.length === 3) updateOptionsInSelector(2, parent);
      });

    $(parent + ' .single-option-selector:eq(1)')
      .off('change.customVariantFix')
      .on('change.customVariantFix', function () {
        if (product.options.length === 3) updateOptionsInSelector(2, parent);
      });
  }

  function initVariantFix() {
    if (typeof Shopify === 'undefined') return;
    if (!Shopify.uniq) return;

    Shopify.updateOptionsInSelector = updateOptionsInSelector;
    Shopify.linkOptionSelectors = linkOptionSelectors;

    $('.js-product_section').find('.product_form').each(function () {
      var product = $(this).data('product');
      var productID = $(this).data('product-id');
      var productSection = '.product-' + productID + ' .js-product_section';

      if (product && productID) {
        linkOptionSelectors(product, productSection);
      }
    });
  }

  $(document).ready(function () {
    setTimeout(initVariantFix, 100);
    setTimeout(initVariantFix, 500);
    setTimeout(initVariantFix, 1000);
  });

  $(document).on('change click', '.swatch :radio, .swatch-element, .single-option-selector', function () {
    setTimeout(initVariantFix, 100);
  });
})();

/* === Show base/from price when no full variant is selected === */
(function () {
  function showBasePrice() {
    $('.js-product_section').each(function () {
      var $section = $(this);
      var $form = $section.find('.product_form').first();
      var product = $form.data('product');

      if (!product || !product.variants || !product.variants.length) return;

      var selectedOptions = [];

      $section.find('.single-option-selector').each(function () {
        selectedOptions.push($(this).val() || '');
      });

      var matchingVariants = product.variants.filter(function (variant) {
        for (var i = 0; i < selectedOptions.length; i++) {
          if (selectedOptions[i] && variant.options[i] !== selectedOptions[i]) {
            return false;
          }
        }
        return true;
      });

      if (!matchingVariants.length) {
        matchingVariants = product.variants;
      }

      var lowestPrice = Math.min.apply(
        null,
        matchingVariants.map(function (variant) {
          return variant.price;
        })
      );

      var formattedPrice = Shopify.formatMoney(
        lowestPrice,
        $('body').data('money-format')
      );

      var allOptionsSelected = selectedOptions.every(function (value) {
        return value !== '';
      });

      if (!allOptionsSelected) {
if (!allOptionsSelected) {
  $section.find('.current_price').html(
    'From <span class="money">' + formattedPrice + '</span><br class="price-select-break">'
  );

  $section.find('.sold_out').css({
    display: 'inline-block',
    marginTop: '4px'
  });
}
      }
    });
  }

  $(document).ready(function () {
    setTimeout(showBasePrice, 300);
    setTimeout(showBasePrice, 1000);
  });

  $(document).on('change click', '.swatch :radio, .swatch-element, .single-option-selector', function () {
    setTimeout(showBasePrice, 150);
  });
})();

/* === Put base price and Select options on separate lines === */
(function () {
  function separateBasePriceAndSelectOptions() {
    $('.js-product_section').each(function () {
      var $section = $(this);
      var $price = $section.find('.current_price');
      var $soldOut = $section.find('.sold_out');

      if ($price.length && $soldOut.length && $price.text().indexOf('From') !== -1) {
        $price.css({
          display: 'block',
          width: '100%',
          marginBottom: '6px'
        });

        $soldOut.css({
          display: 'block',
          width: '100%',
          clear: 'both'
        });
      }
    });
  }

  $(document).ready(function () {
    setTimeout(separateBasePriceAndSelectOptions, 300);
    setTimeout(separateBasePriceAndSelectOptions, 1000);
  });

  $(document).on('change click', '.swatch :radio, .swatch-element, .single-option-selector', function () {
    setTimeout(separateBasePriceAndSelectOptions, 150);
  });
})();

/* === Force price and Select options onto separate flex rows === */
(function () {
  function fixPriceRows() {
    $('.modal_price').each(function () {
      var $priceWrapper = $(this);

      if ($priceWrapper.find('.current_price').text().indexOf('From') !== -1) {
        $priceWrapper.css({
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'flex-start'
        });

        $priceWrapper.find('.price__container').css({
          display: 'block',
          width: '100%'
        });

        $priceWrapper.find('.sold_out_container').css({
          display: 'block',
          width: '100%',
          marginTop: '4px'
        });
      }
    });
  }

  $(document).ready(function () {
    setTimeout(fixPriceRows, 300);
    setTimeout(fixPriceRows, 1000);
  });

  $(document).on('change click', '.swatch :radio, .swatch-element, .single-option-selector', function () {
    setTimeout(fixPriceRows, 150);
  });
})();